import { RangeParams } from '../../../services/dynamo/types'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Transaction } from '../state/types'

export const useTransactionLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {

        const loadTransactions = (dateFrom: Date, dateTo: Date) => {
            const { loadFiltered } = loaders(companyId)
            const ranges: RangeParams = {
                date: {
                    start: dateFrom.toISOString(),
                    end: dateTo.toISOString()
                }
            }
            return loadFiltered(TableName.TRANSACTIONS, true, undefined, ranges) as Promise<Transaction[]>
        }

        const loadSourceTransactions = (
            sourceId: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.TRANSACTIONS, dbRequest, { sourceId }) as Promise<Transaction[]>
        }

        const countTransactions = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.TRANSACTIONS, options)
        }

        return {
            loadTransactions,
            loadSourceTransactions,
            countTransactions
        }
    }
}
